import api from "./axios";
import { ApiKey, ApiKeyCreated, CreateApiKeyRequest } from "../interfaces/ApiKey";

const BASE = "/Integration/api-keys";

export async function getApiKeys(): Promise<ApiKey[]> {
  const { data } = await api.get(BASE);
  return Array.isArray(data) ? data : [];
}

export async function createApiKey(req: CreateApiKeyRequest): Promise<ApiKeyCreated> {
  const { data } = await api.post(BASE, req);
  return data;
}

export async function revokeApiKey(id: number): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}
